import { Controller } from "@hotwired/stimulus"

const DEFAULTS = {
  openai:       "gpt-5",
  anthropic:    "claude-sonnet-4-6",
  xai:          "grok-4-fast-reasoning",
  ollama_cloud: "deepseek-v3.2"
}

// Mirrors LlmConnection::DEFAULT_MODELS — when the user changes provider,
// hide options that don't match and reset the selection to the provider's
// default (or the first remaining option if the default isn't in the list).
export default class extends Controller {
  static targets = ["model"]

  connect() {
    const form = this.element.closest("form")
    this.modelSelect = form?.querySelector('[data-llm-provider-picker-target="model"]')
    this._filterByProvider(this.element.value)
  }

  update(event) {
    this._filterByProvider(event.target.value)
  }

  _filterByProvider(provider) {
    if (!this.modelSelect) return
    const options = Array.from(this.modelSelect.options)
    let firstVisible = null
    for (const opt of options) {
      const matches = opt.dataset.provider === provider
      opt.hidden = !matches
      opt.disabled = !matches
      if (matches && !firstVisible) firstVisible = opt
    }
    const preferred = DEFAULTS[provider]
    const preferredOpt = options.find(o => o.dataset.provider === provider && o.value === preferred)
    if (preferredOpt) {
      this.modelSelect.value = preferred
    } else if (firstVisible) {
      this.modelSelect.value = firstVisible.value
    }
  }
}
